import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import cellEditFactory from "react-bootstrap-table2-editor";

import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  sortCaret,
  headerSortingClasses,
} from "../../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  formatDate,
  showSuccessDialog,
  showErrorDialog,
  StatusFormatter,
  useForceUpdate,
  sizePerPageList,
} from "../../../utility";
import {
  resetData,
  selectRtv,
  selectReasonParam,
  fetchReasonParam,
  uploadFile,
  editRtv,
  selectLoading,
} from "./withrtvSlice";
import DeleteIcon from "@material-ui/icons/Delete";
import ImageIcon from "@material-ui/icons/Image";
import Select from "react-select";
import moment from "moment";
import InputNumber from "../without-rtv/InputNumber";
import { LayoutSplashScreen } from "../../../../_metronic/layout";

export const WithRtvNonRefDetail = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const forceUpdate = useForceUpdate();
  const reasonParam = useSelector(selectReasonParam);
  const data = useSelector(selectRtv);
  const loading = useSelector(selectLoading);

  // Add status field to prevent object is not extensible error
  const initData = data.map((item, index) => ({
    ...item,
    no: index + 1,
    qty: 1,
    returnUom: item.uom,
  }));

  const [tableData, setTableData] = useState(initData);
  const [reason, setReason] = useState("");
  const [remark, setRemark] = useState("");
  const [rowIndexTable, setRowIndexTable] = useState(null);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [pelapor, setPelapor] = useState("");

  const [referenceInvoiceDate, setReferenceInvoiceDate] = useState("");
  const [requestDate, setRequestDate] = useState(
    new Date().getFullYear() +
      "-" +
      (new Date().getMonth() + 1) +
      "-" +
      new Date().getDate()
  );

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());

    // Fetch data on first load
    dispatch(
      fetchReasonParam({
        paramGroupId: "REASON",
        pageNo: 1,
        pageSize: 20,
      })
    );
  }, [dispatch]);

  const optionsTablePage = {
    showTotal: true,
    totalSize: tableData.length,
    sizePerPageList: sizePerPageList,
  };

  // Return if data null
  if (!tableData.length > 0) {
    history.push("/new-return/with-rtv");
  }

  const reasonOptions = reasonParam.map((e) => {
    return {
      value: e.paramCode,
      label: e.paramValue,
    };
  });

  const getValueReason = (value, options) => {
    console.log(value, "value");
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  // UOM Render
  const getValueUom = (value, options) => {
    console.log(value);
    console.log(options.filter((val) => value === val.label));
    return options.filter((val) => value === val.label);
  };

  const handleUomValueChange = async (
    e,
    row,
    rowIndex,
    options,
    formatExtraData
  ) => {
    const selected = options.filter((val) => e.value === val.label);

    const uom = selected[0];
    formatExtraData[rowIndex].returnUom = e.value;
    formatExtraData[rowIndex].qty =
      (formatExtraData[rowIndex].qty / uom.numerator) * uom.denumerator;
    console.log(formatExtraData);
    setTableData(formatExtraData);
    forceUpdate();
  };

  const renderUom = (cell, row, rowIndex, formatExtraData) => {
    const alt_uom = row.altUom;
    let cell_uom = cell;

    const options_this = [
      { value: "", label: "", numerator: "", denumerator: "" },
    ];

    alt_uom.map((value, index) => {
      options_this.push({
        value: value.uom,
        label: value.uom,
        numerator: value.numerator,
        denumerator: value.denumerator,
      });
    });

    return (
      <Select
        isSearchable={false}
        className="uom-select"
        menuPortalTarget={document.body}
        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        key={`uom-${rowIndex}`}
        options={options_this}
        onChange={(e) =>
          handleUomValueChange(e, row, rowIndex, options_this, formatExtraData)
        }
        value={getValueUom(cell_uom, options_this)}
      />
    );
  };

  const handleQtyChange = async (newValue, row, column, tableData) => {
    const uuid = row.uuid;
    let indexRow = "";
    tableData.filter((value, index) => {
      if (value.uuid === uuid) {
        indexRow = index;
      }
    });
    const int_val = parseFloat(newValue);
    const _qty = parseFloat(tableData[indexRow].qty);

    if (int_val > _qty) {
      forceUpdate();
      return;
    } else if (int_val < 0) {
      forceUpdate();
      return;
    }

    tableData[indexRow].qty = int_val;
    const done = await data(tableData);
    forceUpdate();
    return done;
  };

  // function Upload

  const uploadFormatter = (cell, row, rowIndex, formatExtraData) => {
    let render = (
      <div>
        <input
          type="file"
          onChange={(e) =>
            handleUpload(e, rowIndex, row, cell, formatExtraData)
          }
          style={{ color: "transparent", width: "91px" }}
          // accept="image/*"
          accept="image/png, image/jpeg, image/jpg"
        />
      </div>
    );

    if (row.attachmentId) {
      render = (
        <div className="filename-container">
          <div className="div-filename">{row.filename}</div>
          <a
            href={`${process.env.REACT_APP_API_URL}/return/attachment/${row.attachmentId}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <ImageIcon style={{ color: "#648DAE", marginRight: "5px" }} />
          </a>
          <DeleteIcon
            onClick={(e) => handleDeleteFile(e, rowIndex, formatExtraData)}
          />
        </div>
      );
    }

    // if (formatExtraData.reason === "132") {
    //   render = "cannot upload";
    // }

    return render;
  };

  const handleUpload = async (e, rowIndex, row, cell, formatExtraData) => {
    const file = e.target.files[0];
    const params = {
      file: file,
    };
    try {
      const response = await dispatch(uploadFile(params));
      if (response.payload.status === 200) {
        // const action = await showSuccessDialog(response.payload.data);

        const temp = tableData;
        temp[rowIndex].attachmentId = response.payload.data;
        temp[rowIndex].filename = file.name;
        setTableData(temp);
        forceUpdate();
      }
    } catch (error) {
      console.log(error);
      showErrorDialog("Something went wrong!");
    }
  };

  const handleDeleteFile = async (e, rowIndex) => {
    const temp = tableData;
    temp[rowIndex].attachmentId = null;
    temp[rowIndex].filename = null;
    forceUpdate();
  };

  const handleInputQtyChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].qty = e.target.value;
    setTableData(formatExtraData);
    forceUpdate();
  };

  const inputQtyFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        value={row.qty}
        // onChange={(e) =>
        //   handleInputQtyChange(e, row, rowIndex, formatExtraData)
        // }
      />
    );
  };

  // function Remark
  const handleRemarkRowChange = (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].remarkRow = e.target.value;
    setTableData(formatExtraData);
  };

  const remarkFormatter = (cell, row, rowIndex, formatExtraData) => {
    return (
      <div>
        <Form.Control
          className={`remark-brqa`}
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: "80px" }}
          onChange={(e) =>
            handleRemarkRowChange(e, row, rowIndex, formatExtraData)
          }
          maxLength={255}
        />
      </div>
    );
  };

  const handleNetPriceChange = async (e, row, rowIndex, formatExtraData) => {
    formatExtraData[rowIndex].netPrice = e.target.value;
    setTableData(formatExtraData);
  };

  const netPriceFormmater = (cell, row, rowIndex, formatExtraData) => {
    return (
      <Form.Control
        type="number"
        step="any"
        className="remark-brqa"
        value={row.netPrice}
      />
    );
  };

  const handleDraft = () => {
    setBtnDisabled(true);
    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });
    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
        returnDetailId: e.returnDetailId,
        division: e.division,

      };
    });
    const id = tableData[0].returnId;

    const params = {
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      plantCode: tableData[0].plantCode.toString(),
      reasonCode: reason,
      transactionDate: moment(tableData[0].transactionDate).format(
        "YYYY-MM-DD"
      ),
      dataSource: "NONREF",
      returnType: "NONREFMTKA",
      remark: remark,
      draft: true,
      rtvNo: tableData[0].rtvNo,
      rtvDate: tableData[0].rtvDate,
      rtvReceivingDate: tableData[0].rtvReceivingDate,
      remarksRtv: tableData[0].remarksRtv,
      reporter: pelapor,
      items: items,
    };
    console.log(params, "params");
    callApi({ params, id });
  };

  const handleSave = () => {
    setBtnDisabled(true);
    //checking attachment
    const attachmentChecker = [];
    tableData.map((val, index) => {
      if (val.attachmentId) {
      } else {
        attachmentChecker.push(index);
      }
    });

    const netPriceChecker = [];
    tableData.map((val, index) => {
      if (val.netPrice) {
      } else {
        netPriceChecker.push(index);
      }
    });

    if (reason === undefined) {
      setBtnDisabled(false);
      return showErrorDialog("Please Select Reason !");
    }

    if (reason !== "132" && attachmentChecker.length > 0) {
      setBtnDisabled(false);
      return showErrorDialog("Please Upload Image !");
    }

    if (netPriceChecker.length > 0) {
      setBtnDisabled(false);
      return showErrorDialog("Please Input Net Price First !");
    }

    if (referenceInvoiceDate === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please Select Reference Invoice Date First !");
    }
    if (tableData.netPrice === 0) {
      setBtnDisabled(false);
      return showErrorDialog("Please Input Net Price First !");
    }
    if (reason === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please Select Reason First !");
    }
    
    if (remark === "") {
      setBtnDisabled(false);
      return showErrorDialog("Please fill in the remark !");
    }

    // Setup Request Body Params
    tableData.map((value) => {
      if (reason === "132") {
        value.sloc = "B41";
      } else if (reason === "135") {
        value.sloc = "B42";
      }
      if (value.returnUom) {
      } else {
        value.returnUom = value.uom;
      }
    });

    const items = tableData.map((e) => {
      return {
        attachmentId: e.attachmentId,
        batch: e.batch,
        clientCode: e.clientCode,
        clientName: e.clientName,
        crprgp: e.crprgp,
        expiredDate: e.expiredDate,
        materialCode: e.materialCode,
        materialName: e.materialName,
        materialRemarks: e.materialRemarks,
        netPrice: e.netPrice,
        nra: e.nra,
        returnDetailId: e.returnDetailId,
        qty: e.qty,
        returnUom: e.returnUom,
        sloc: e.sloc,
        uom: e.uom,
        remark: e.remarkRow,
        rayonType: e.rayonType,
        line: e.line,
        division: e.division,

      };
    });
    const id = tableData[0].returnId;

    const params = {
      customerCode: tableData[0].customerCode.toString(),
      customerCodeOrigin: tableData[0].customerCodeOrigin,
      distributionChannel: tableData[0].distributionChannel,
      reasonCode: reason,
      plantCode: tableData[0].plantCode,
      dataSource: "NONREF",
      returnType: "NOREFMTKA",
      remark: remark,
      draft: false,
      rtvNo: tableData[0].rtvNo,
      rtvDate: tableData[0].rtvDate,
      rtvReceivingDate: tableData[0].rtvReceivingDate,
      remarksRtv: tableData[0].remarksRtv,
      customerPODate: moment(requestDate).format("YYYY-MM-DD"),
      transactionDate: referenceInvoiceDate,
      reporter: pelapor,
      items: items,
    };
    console.log(params, "params");

    callApi({ params, id });
  };

  const callApi = async ({ params, id }) => {
    try {
      const response = await dispatch(editRtv({ params, id }));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(
          "Data has been saved!",
          `Return have been Saved, your return number : <strong>${response.payload.data.data.retNumber}</strong>`
        );
        if (action.isConfirmed) history.push("/new-return/with-rtv");
        setBtnDisabled(false);
      } else {
        showErrorDialog(response.payload.message);
      }
    } catch (error) {
      console.log("error", error);
      showErrorDialog(error);
      setBtnDisabled(false);
    }
  };

  const StatusCrpFormatter = (cellContent, row) => {
    let label = "";
    if (cellContent === "Y") {
      label = "Within CRP";
    } else if (cellContent === "N") {
      label = "Non CRP";
    } else if (cellContent === "N/A") {
      label = "N/A";
    }

    return <span>{label}</span>;
  };

  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },

    {
      text: "Material",
      dataField: "materialCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Material Desc",
      dataField: "materialName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Client Code",
      dataField: "clientCode",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Client Name",
      dataField: "clientName",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Batch",
      dataField: "batch",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "Exp Date",
      dataField: "expiredDate",
      sort: true,
      formatter: formatDate,
      sortCaret: sortCaret,
      headerSortingClasses,
      editable: false,
    },
    {
      text: "UOM",
      dataField: "returnUom",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: renderUom,
      formatExtraData: tableData,
      editable: false,
    },

    {
      text: "Qty",
      dataField: "qty",
      sort: true,
      type: "number",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: inputQtyFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      // formatExtraData: tableData,
      // editable: false,
    },
    {
      text: "Net Price",
      dataField: "netPrice",
      sort: true,
      type: "number",
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: netPriceFormmater,
      editorRenderer: (editorProps, value) => {
        return <InputNumber {...editorProps} value={value} />;
      },
      formatExtraData: tableData,
    },
    {
      text: "CRP/RGP",
      dataField: "crprgp",
      formatter: StatusCrpFormatter,
      align: "center",
      editable: false,
    },
    {
      text: "Photo Product",
      dataField: "attachmentId",
      // hidden: reason === "132" ? true : false,
      formatter: (cell, row, rowIndex, formatExtraData) =>
        uploadFormatter(cell, row, rowIndex, formatExtraData),
      formatExtraData: {
        reason: reason,
        tableData: tableData,
      },
      editable: false,
    },
    {
      text: "Remarks",
      dataField: "remarkRow",
      formatter: remarkFormatter,
      formatExtraData: tableData,
      editable: false,
    },
  ];

  return tableData.length > 0 ? (
    loading ? (
      <LayoutSplashScreen />
    ) : (
      <>
        <Card>
          <CardHeader title="With RTV Non Ref"></CardHeader>
          <CardBody>
            <Form>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>RTV Number </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].rtvNo}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>RTV Date </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].rtvDate}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Name</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].customerName}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Code</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].customerCode}
                      />
                    </Col>
                  </Form.Group>
                  {/* <Form.Group as={Row}>
                  <Form.Label column sm={4}>
                    <b>Sales Division</b>
                  </Form.Label>
                  <Col sm={5}>
                    <Form.Control
                      type="text"
                      disabled
                      value={tableData[0].salesDivision}
                    />
                  </Col>
                </Form.Group> */}
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Distribution Channel</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].distributionChannel}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reporter</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        value={pelapor}
                        onChange={(e) => setPelapor(e.target.value)}
                      />
                    </Col>
                  </Form.Group>
                </Col>

                {/* Right Row */}
                <Col sm={6}>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Plant Code</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="text"
                        disabled
                        value={tableData[0].plantCode}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reason </b>
                    </Form.Label>
                    <Col sm={5}>
                      <Select
                        options={reasonOptions}
                        value={getValueReason(reason, reasonOptions)}
                        placeholder="Select Reason..."
                        onChange={(e) => {
                          setReason(e.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Customer Request Date</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="date"
                        onChange={(e) => {
                          setRequestDate(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Reference Invoice Date</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        type="date"
                        onChange={(e) => {
                          setReferenceInvoiceDate(e.target.value);
                        }}
                      />
                    </Col>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={4}>
                      <b>Remark</b>
                    </Form.Label>
                    <Col sm={5}>
                      <Form.Control
                        as="textarea"
                        // onChange={handleRemarkChange}
                        onChange={(e) => {
                          setRemark(e.target.value);
                        }}
                        placeholder="Leave a comment here"
                        maxLength={35}
                        style={{ height: "100px" }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Form.Group>

              {/* Table Material*/}
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                keyField="uuid"
                data={tableData}
                columns={columns}
                pagination={paginationFactory(optionsTablePage)}
                hover
                cellEdit={cellEditFactory({
                  mode: "click",
                  blurToSave: true,
                })}
              />
            </Form>

            <Form>
              <Row>
                <Col md="6" sm="6" lg="8">
                  <Button
                    variant="primary"
                    className="mr-5"
                    onClick={handleDraft}
                    disabled={btnDisabled}
                  >
                    Draft
                  </Button>
                  <Button
                    variant="success"
                    className="mr-5"
                    disabled={btnDisabled}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                  <Button
                    variant="secondary"
                    className="mr-5"
                    onClick={() => history.push("/new-return/with-rtv")}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </>
    )
  ) : null;
};
